import React, { useState } from "react";

const FAQ = ({ data, ui }) => {
  return (
    <div id="faq">
      <div className="container">
        <div className="col-md-10 col-md-offset-1 section-title text-center">
          <h2>{ui?.title}</h2>
        </div>
        <div className="row">
          {data?.map((item, index) => (
            <FAQItem
              key={index}
              question={item.question}
              answer={item.answer}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

const FAQItem = ({ question, answer }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="col-xs-12">
      <div
        className="faq-card"
        onClick={() => setIsExpanded(!isExpanded)}
        style={{ cursor: "pointer" }}
      >
        <h4 className="faq-question">{question}</h4>
        {isExpanded && <p className="faq-answer"> {answer}</p>}
      </div>
    </div>
  );
};

export default FAQ;
